import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
// import { useSnackbar } from 'notistack';
import AdminLoader from '../../../../../components/common/loader/AdminLoader';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileUploadSales from '../ResponseReceived/FileUploadSales';
import { fetchEmployeeGroups } from '../../../../../store/slices/employeeGroup';
import { fetchEmployees } from '../../../../../store/slices/employeeSlice';
import ProjectApprovedSub from './ProjectApprovedSub';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { MdSearch } from "react-icons/md";
import "react-datepicker/dist/react-datepicker.css";
import { updateAllProjectDueDatesByQuotationId } from '../../../../../store/slices/projectDueDateSlice';
import DatePicker from "react-datepicker";
import DateConversion from '../../../../../utils/DateConversion';
import { fetchGroups } from '../../../../../store/slices/groupSlice';
import useToolGuideSync from '../../../../../features/toolGuide/useToolGuideSync';
import { BUCKET_KEYS } from '../../../../../features/toolGuide/toolGuideConfig';
// import { createProjectRequest } from '../../../../../store/slices/managerProjectRequestedSlice';
// import { fetchAllProjects } from '../../../../../store/slices/projectsSlice';
// import { fetchLeads } from '../../../../../store/slices/leadsSlice';

const ApprovedSales = ({ projectsApprovedSales, handlerefresh, isViewOnly = false }) => {
    const dispatch = useDispatch();
    // const { enqueueSnackbar } = useSnackbar();
    const { formatDateByCountry, getDatePlaceholder, getDateFormat } = DateConversion();
    const { syncToolGuideStep } = useToolGuideSync(BUCKET_KEYS.PROJECT_APPROVED);
    const { employees } = useSelector((state) => state.employees);
    const { group: masterGroups } = useSelector((state) => state.group);
    // const { groups } = useSelector((state) => state.employeeGroup);
    const [mergedData, setMergedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showAttach, setShowAttach] = useState(false);
    const [sortedProjects, setSortedProjects] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [rowid, setrowid] = useState(null);
    const [currentProject, securrentProject] = useState(null);
    const [rowData, setRowData] = useState([]);
    // const [selectedManagerForRow, setSelectedManagerForRow] = useState({});
    // const [ setOpenSelectManagerRow] = useState(null);

    useEffect(() => {
        dispatch(fetchEmployeeGroups());
        dispatch(fetchEmployees());
        dispatch(fetchGroups());
    }, [dispatch]);

    const resolveId = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value;
        return value?._id || value?.id || "";
    };

    const getRowGroupName = (row) => {
        if (row?.AssignedGroup) return row.AssignedGroup;

        const groupId =
            resolveId(row?.groupid) ||
            resolveId(row?.lead?.groupid) ||
            resolveId(row?.projects?.[0]?.groupid);

        if (!groupId) return "";

        const matchedGroup = (masterGroups || []).find(
            (grp) => resolveId(grp) === groupId
        );

        return (
            matchedGroup?.newGroupName ||
            matchedGroup?.GroupName ||
            matchedGroup?.groupName ||
            matchedGroup?.name ||
            ""
        );
    };

    // Show all Won leads: no project = select option, has project = list of managers (differentiate by quotationId)
    useEffect(() => {
        const updatedProjects = (projectsApprovedSales || []).map(item => {
            const leadDate = item.LeadDate ? new Date(item.LeadDate) : new Date();
            const dueDate = new Date(leadDate.getTime() + 7 * 24 * 60 * 60 * 1000);
            return { ...item, DueDate: dueDate.toISOString() };
        });
        setMergedData(updatedProjects);
    }, [projectsApprovedSales]);







    // useEffect(() => {
    //     if (leads?.length && projectsApprovedSales?.length) {

    //         const excludedStatuses = ["Won", "won", "Won Recurring", "won recurring"];

    //         const filteredLeads = leads.filter(
    //             (lead) => excludedStatuses.includes(lead.Status)
    //         );

    //         // Sort leads by createdAt date (newest first)
    //         const sortedLeads = filteredLeads.sort((a, b) => {
    //             const dateA = new Date(a.createdAt || a.LeadDate);
    //             const dateB = new Date(b.createdAt || b.LeadDate);
    //             return dateB - dateA; // Descending order (newest first)
    //         });

    //         // Create merged array where leads get their matching projects
    //         const mergedArray = sortedLeads.map(lead => {
    //             // Find projects that match the lead's ProjectName
    //             const matchingProjects = projectsApprovedSales.filter(
    //                 project => project.ProjectName === lead.ProjectName
    //             );

    //             // If projects found, add them to the lead
    //             if (matchingProjects.length > 0) {
    //                 return {
    //                     ...lead,
    //                     projects: matchingProjects.flatMap(project => project.Projects || [])
    //                 };
    //             }

    //             // If no projects found, return lead with empty projects array
    //             return {
    //                 ...lead,
    //                 projects: []
    //             };
    //         });
    //         setMergedData(mergedArray);
    //     }
    // }, [leads, projectsApprovedSales]);

    // Filter data based on search query


    // useEffect(() => {
    //     setSortedProjects(mergedData);
    // }, [mergedData]);

    useEffect(() => {
        if (!searchQuery.trim()) {
            setSortedProjects(mergedData);
        }
    }, [mergedData, searchQuery]);


    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);

    // Reset to first page when search query changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    const totalItems = sortedProjects?.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const startIdx = (currentPage - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage;
    const paginatedProjects = sortedProjects?.slice(startIdx, endIdx);
console.log("paginatedProjects approved sales", paginatedProjects)
    const handleSearchInputChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        filterLeadReports(query)
    };

    const filterLeadReports = (query) => {
        const lowerCaseQuery = query.toLowerCase().trim();
        const filtered = mergedData.filter((LeadReport) =>
            Object.entries(LeadReport).some(([key, value]) => {
                // Skip these keys
                if (
                    key === "Assignedperson" ||
                    key === "TypeService" ||
                    key === "SalesPersonName" ||
                    key === "SalesPersonEmail" ||
                    key === "ResourceType" ||
                    key === "QuotedValue" ||
                    key === "ProjectManagerStatus" ||
                    key === "ProjectManagerAction" ||
                    key === "createdAt" ||
                    key === "updatedAt" ||
                    key === "PrimaryResources"
                )
                    return false;

                if (value === null || value === undefined) return false;
                if (key === "ProjectDueDate" || key === "LeadDate" || key === "DueDate") {
                    const formattedDate = formatDateByCountry(value);  // ← change here
                    return formattedDate.toLowerCase().includes(lowerCaseQuery);
                }
                if (key === "AssignedGroup" || key === "groupid") {
                    return getRowGroupName(LeadReport).toLowerCase().includes(lowerCaseQuery);
                }
                // Handle all other fields
                const formattedValue = value.toString().trim().toLowerCase();
                return formattedValue.includes(lowerCaseQuery);
            })
        );
        setSortedProjects(filtered);
    };

    const sortAlphabetically = (targetToSort, order) => {
        const key = `${targetToSort}-${order}`;
        let sorted = [...sortedProjects]; // Always sort from the filtered dataset

        const compareStrings = (a, b) => {
            const valA = (a || "").toString().toLowerCase();
            const valB = (b || "").toString().toLowerCase();
            return valA.localeCompare(valB);
        };
        // Helper function for date comparison
        const compareDates = (a, b) => {
            const dateA = a ? new Date(a) : null;
            const dateB = b ? new Date(b) : null;

            if (!dateA && !dateB) return 0;
            if (!dateA) return 1;
            if (!dateB) return -1;

            return dateA - dateB;
        };

        switch (key) {
            case "AssignedGroup-az":
                sorted.sort((a, b) => compareStrings(getRowGroupName(a), getRowGroupName(b)));
                break;
            case "AssignedGroup-za":
                sorted.sort((a, b) => compareStrings(getRowGroupName(b), getRowGroupName(a)));
                break;
            case "ProjectName-az":
                sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
                break;
            case "ProjectName-za":
                sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
                break;
            case "LeadDate-az":
                sorted.sort((a, b) => compareDates(a.LeadDate, b.LeadDate));
                break;
            case "LeadDate-za":
                sorted.sort((a, b) => compareDates(b.LeadDate, a.LeadDate));
                break;
            case "ProjectDueDate-az":
                sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
                break;
            case "ProjectDueDate-za":
                sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
                break;
            default:
                // Default to original filtered order
                sorted = [...sortedProjects];
                break;
        }

        setSortedProjects(sorted);
        setCurrentPage(1); // Reset to first page after sorting
    };




    const [selected, setSelected] = useState(false);

    const ProjectApprovedref = useRef(null);
    useEffect(() => {
        if ((rowid)) {
            // Scroll to the right end of the container
            const scrollToPosition = ProjectApprovedref.current.scrollWidth;
            ProjectApprovedref.current.scrollTo({
                left: scrollToPosition,
                behavior: 'smooth'
            });
        }
    }, [rowid]);


    const handleDueDateChange = async (row, date, projectName, quotationId) => {
        if (isViewOnly) return;
        if (!date || !projectName) return;

        if (row.projects && row.projects.length > 0) {
            setIsLoading(true);
            try {
                await dispatch(updateAllProjectDueDatesByQuotationId({
                    quotationId: quotationId || projectName,
                    ProjectDueDate: date,
                }));
            } catch (error) {
                console.error("Failed to update due date:", error);
                // Optional: Show error message
                // enqueueSnackbar("Failed to update due date", { variant: "error" });
            } finally {
                setIsLoading(false);
                handlerefresh()
            }

        } else {
            setRowData(prevData => {
                // Directly-won leads often have quotationId but no projects yet — key by both.
                const existingIndex = prevData.findIndex(
                    (item) =>
                        (quotationId != null &&
                            String(quotationId).trim() !== "" &&
                            item.quotationId != null &&
                            String(item.quotationId) === String(quotationId)) ||
                        item.projectName === row.ProjectName ||
                        item.projectName === projectName
                );
                const entry = {
                    projectName: row.ProjectName || projectName,
                    quotationId: quotationId || null,
                    ProjectDueDate: date,
                };

                if (existingIndex >= 0) {
                    return prevData.map((item, index) =>
                        index === existingIndex ? { ...item, ...entry } : item
                    );
                }
                return [...prevData, entry];
            });
        }


    };

    // Row identity: quotationId differentiates same (Group, ClientName, ProjectName) leads
    const getRowKey = (row) => (row?.quotationId != null && String(row.quotationId).trim() !== "")
        ? String(row.quotationId).trim()
        : (row?.ProjectName || "");

    const handleparentrefresh = () => {
        handlerefresh();
    };

    // const getFilteredManagersForRow = (row) => {
    //     const groupName = (row?.AssignedGroup || "").trim().toLowerCase();
    //     if (!groupName) return [];
    //     if (groups?.length) {
    //         const fromGroups = groups.filter(
    //             (g) => g?.employeeId?.EmpGroups?.some((eg) => String(eg || "").trim().toLowerCase() === groupName)
    //         );
    //         if (fromGroups.length > 0) return fromGroups;
    //     }
    //     return (employees || []).filter(
    //         (emp) => emp?.EmpGroups?.some((eg) => String(eg || "").trim().toLowerCase() === groupName)
    //     ).map((emp) => ({ employeeId: emp }));
    // };

    // const handleForwardToManager = async (row) => {
    //     const rowKey = getRowKey(row);
    //     const selected = selectedManagerForRow[rowKey];
    //     if (!selected?.email) {
    //         enqueueSnackbar("Please select a manager", { variant: "warning" });
    //         return;
    //     }
    //     const project = [{
    //         AssignedManagerEmail: [selected.email],
    //         ProjectName: row.ProjectName,
    //         quotationId: row.quotationId || null,
    //     }];
    //     const formData = new FormData();
    //     formData.append("projects", JSON.stringify(project));
    //     setIsLoading(true);
    //     try {
    //         await dispatch(createProjectRequest(formData)).unwrap();
    //         enqueueSnackbar("Project forwarded to manager successfully", { variant: "success" });
    //         dispatch(fetchAllProjects());
    //         dispatch(fetchLeads());
    //         handlerefresh();
    //         setSelectedManagerForRow((prev) => ({ ...prev, [rowKey]: null }));
    //         setOpenSelectManagerRow(null);
    //     } catch (err) {
    //         const msg = err?.error || err?.message || "Failed to forward project";
    //         enqueueSnackbar(msg, { variant: "error" });
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };
    return (
        <div>
            {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}

            <div className="pt-2">
                <div className="flex justify-between items-center p-2 bg-white rounded-t">
                    <div className=" font-semibold">
                        <h3> Project Approved</h3>
                    </div>

                    <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
                        <MdSearch className=" w-5 h-5 text-gray-500" />
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search"
                            className="bg-[#e0e7ff] outline-none w-[80%]"
                        />
                    </div>
                </div>

                <div ref={ProjectApprovedref} className=" w-full min-h-[15rem] max-h-[90vh] overflow-auto bg-white  h-full justify-center pb-5">
                    <div className="z-[50] sticky top-0 w-full">
                        {/* Rest of your table header code remains the same */}
                        <div className="flex  text-xs bg-[#e8e8e8] font-semibold ">
                            <div className={`${rowid ? "" : "w-[80%]"}`}>
                                <div className={` flex`}>
                                    <div className="w-14 bg-[#e8e8e8] h-12 p-2 border-b flex justify-start align-middle items-center">Sr. No</div>
                                    <div className={` ${rowid ? "w-24" : "w-[20%]"} h-12 relative  bg-[#e8e8e8] border-b p-2 break-words text-wrap flex justify-between align-middle items-center `}>
                                        Group
                                        <div className="flex flex-col absolute right-1">
                                            <div
                                                className="cursor-pointer "
                                                onClick={() =>
                                                    sortAlphabetically("AssignedGroup", "az")
                                                }
                                            >
                                                <ArrowDropUp
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                            <div
                                                className="cursor-pointer -mt-2"
                                                onClick={() =>
                                                    sortAlphabetically("AssignedGroup", "za")
                                                }
                                            >
                                                <ArrowDropDown
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${rowid ? "w-28" : "w-[20%]"}  h-12 relative bg-[#e8e8e8] border-b p-2 break-words text-wrap flex justify-between align-middle items-center`}>
                                        Project Name
                                        <div className="flex flex-col absolute right-1">
                                            <div
                                                className="cursor-pointer "
                                                onClick={() =>
                                                    sortAlphabetically("ProjectName", "az")
                                                }
                                            >
                                                <ArrowDropUp
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                            <div
                                                className="cursor-pointer -mt-2"
                                                onClick={() =>
                                                    sortAlphabetically("ProjectName", "za")
                                                }
                                            >
                                                <ArrowDropDown
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${rowid ? "w-32" : "w-[20%]"}  h-12 relative bg-[#e8e8e8] border-b p-2 break-words text-wrap flex justify-center align-middle items-center`}>
                                        Date Requested{" "}
                                        <div className="flex flex-col absolute right-0">
                                            <div
                                                className="cursor-pointer "
                                                onClick={() =>
                                                    sortAlphabetically("LeadDate", "az")
                                                }
                                            >
                                                <ArrowDropUp
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                            <div
                                                className="cursor-pointer -mt-2"
                                                onClick={() =>
                                                    sortAlphabetically("LeadDate", "za")
                                                }
                                            >
                                                <ArrowDropDown
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${rowid ? "w-28" : "w-[20%]"} h-12 relative bg-[#e8e8e8] border-b p-2 break-words text-wrap flex justify-center align-middle items-center`}>
                                        Due Date
                                        <div className=" flex flex-col absolute right-1">
                                            <div
                                                className="cursor-pointer "
                                                onClick={() =>
                                                    sortAlphabetically("ProjectDueDate", "az")
                                                }
                                            >
                                                <ArrowDropUp
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                            <div
                                                className="cursor-pointer -mt-2"
                                                onClick={() =>
                                                    sortAlphabetically("ProjectDueDate", "za")
                                                }
                                            >
                                                <ArrowDropDown
                                                    color="white"
                                                    sx={{ fontSize: "22px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${rowid ? "w-28" : "w-[20%]"}  h-12  bg-[#e8e8e8] border-b p-2 break-words text-wrap flex justify-center align-middle items-center`}>
                                        Attachment
                                    </div>
                                </div>
                            </div>
                            {rowid ? (
                                <div>

                                    <div className='flex'>
                                        <div className="w-36 border-b h-12 p-2 py-4 break-words text-wrap flex justify-center align-middle items-center bg-[#e8e8e8]">
                                            Assign To Managers
                                        </div>
                                        <div className="w-80 border-b h-12 break-words text-wrap flex flex-col justify-center align-middle items-center bg-[#e8e8e8]">
                                            <div className="w-full  p-2 h-[50%] break-words text-wrap flex justify-center items-center" >
                                                Task Details
                                            </div>
                                            <div className="w-full h-[50%] break-words text-wrap flex ">
                                                <div className="w-[33%] p-2  flex justify-center items-center">
                                                    Resources
                                                </div>
                                                <div className="w-[33%] p-2   flex justify-center items-center">
                                                    Hours/Parts
                                                </div>
                                                <div className="w-[34%] p-2 flex justify-center items-center">
                                                    Expenses
                                                </div>
                                            </div>
                                        </div>
                                        <div className="w-32 border-b h-12 p-2 py-4 break-words text-wrap flex justify-center align-middle items-center bg-[#e8e8e8]">
                                            Action
                                        </div>
                                    </div>
                                </div>

                            ) : (
                                    <div className='flex w-[20%] h-12 border-b  justify-center align-middle items-center bg-[#e8e8e8]'>
                                    <h3> Task Details</h3>

                                </div>
                            )}


                        </div>
                    </div>

                    <div className="w-full">
                        {paginatedProjects.length > 0 ? (
                            paginatedProjects.map((row, index) => {
                                const rowKey = getRowKey(row);
                                const isExpanded = rowid === rowKey;
                                return (
                                <div
                                    className={`flex text-xs w-full ${row.isRead === false ? "font-bold" : ""}  hover:bg-gray-100  group`}
                                    key={rowKey || index}
                                >
                                    <div className={` flex ${rowid ? "" : "w-[80%]"} `}>
                                        <div
                                            onClick={() => {
                                                syncToolGuideStep("view-details");
                                                setrowid(prev => prev === rowKey ? null : rowKey);
                                                setSelected(!selected);
                                            }}
                                            className="w-14 p-2 border-b text-black cursor-pointer flex justify-start align-middle items-center ">
                                            {startIdx + index + 1}
                                        </div>
                                        <div onClick={() => {
                                            syncToolGuideStep("view-details");
                                            setrowid(prev => prev === rowKey ? null : rowKey);
                                            setSelected(!selected);
                                        }}
                                            className={`${rowid ? "w-24" : "w-[20%]"} border-b cursor-pointer  flex justify-start align-middle items-center  p-2 break-words text-wrap`}>
                                            {getRowGroupName(row)}
                                        </div>
                                        <div onClick={() => {
                                            syncToolGuideStep("view-details");
                                            setrowid(prev => prev === rowKey ? null : rowKey);
                                            setSelected(!selected);
                                        }}
                                            className={`${rowid ? "w-28" : "w-[20%]"} border-b cursor-pointer  flex justify-start align-middle items-center text-left p-2 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}>
                                            {row.ProjectName}
                                        </div>
                                        <div onClick={() => {
                                            setrowid(prev => prev === rowKey ? null : rowKey);
                                            setSelected(!selected);
                                        }}
                                            className={`${rowid ? "w-32" : "w-[20%]"} border-b cursor-pointer  flex justify-center align-middle items-center p-2 break-words text-wrap`}>
                                            {row.LeadDate && !isNaN(new Date(row.LeadDate))
                                                ? formatDateByCountry(row.LeadDate)
                                                : " "}
                                        </div>
                                        <div className={`${rowid ? "w-28" : "w-[20%]"}  border-b cursor-pointer  flex justify-center align-middle items-center break-words text-wrap`}>
                                            {!row.projects?.some(project => project.oldprojectid) ? (
                                                <div className="w-[80%] ">
                                                    {(() => {
                                                        const rowKey = getRowKey(row);
                                                        const matchingRowData = rowData?.find(
                                                            (data) =>
                                                                (row.quotationId != null &&
                                                                    String(row.quotationId).trim() !== "" &&
                                                                    data.quotationId != null &&
                                                                    String(data.quotationId) === String(row.quotationId)) ||
                                                                data.projectName === row.ProjectName ||
                                                                data.projectName === rowKey
                                                        );
                                                        // ✅ Determine the selected date (priority order)
                                                        const rawSelected =
                                                            matchingRowData?.ProjectDueDate
                                                                ? new Date(matchingRowData.ProjectDueDate)
                                                                : row.projects?.[0]?.ProjectDueDate
                                                                    ? new Date(row.projects[0].ProjectDueDate)
                                                                    : row.ProjectDueDate
                                                                        ? new Date(row.ProjectDueDate)
                                                                        : null;
                                                        const selectedDate =
                                                            rawSelected && !isNaN(rawSelected.getTime())
                                                                ? rawSelected
                                                                : null;

                                                        return (
                                                            <DatePicker
                                                                selected={selectedDate}
                                                                onChange={(date) =>
                                                                    handleDueDateChange(row, date, getRowKey(row), row.quotationId)
                                                                }
                                                                dateFormat={getDateFormat()}
                                                                className={`ProjectDueDateSelector w-full text-center outline-none border border-gray-300 p-2 group-hover:bg-gray-100 rounded-md bg-white ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                                                                placeholderText={getDatePlaceholder()}
                                                                popperClassName="z-[1500]"
                                                                minDate={new Date()}
                                                                disabled={isViewOnly}
                                                            />
                                                        );
                                                    })()}
                                                </div>
                                            ) : (
                                                // Show due date as plain text if any project has oldprojectid
                                                <div className="text-center ">
                                                    {(() => {
                                                        const rowKey = getRowKey(row);
                                                        const matchingRowData = rowData?.find(
                                                            (data) =>
                                                                (row.quotationId != null &&
                                                                    String(row.quotationId).trim() !== "" &&
                                                                    data.quotationId != null &&
                                                                    String(data.quotationId) === String(row.quotationId)) ||
                                                                data.projectName === row.ProjectName ||
                                                                data.projectName === rowKey
                                                        );

                                                        const displayDate =
                                                            matchingRowData?.ProjectDueDate
                                                                ? new Date(matchingRowData.ProjectDueDate)
                                                                : row.projects?.[0]?.ProjectDueDate
                                                                    ? new Date(row.projects[0].ProjectDueDate)
                                                                    : row.ProjectDueDate
                                                                        ? new Date(row.ProjectDueDate)
                                                                        : null;

                                                        return displayDate && !isNaN(displayDate.getTime())
                                                            ? formatDateByCountry(displayDate)
                                                            : " ";
                                                    })()}
                                                </div>
                                            )}
                                        </div>

                                        <div className={`${rowid ? "w-28" : "w-[20%]"} border-b cursor-pointer  p-2 text-center flex justify-center align-middle items-center break-words text-wrap`}>
                                            <AttachFileIcon
                                                className="rotate-12 cursor-pointer"
                                                onClick={() => {
                                                    setShowAttach(true);
                                                    securrentProject(row);
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {isExpanded ? (
                                        // row.projects?.length === 0 ? (
                                        //     <div className="flex flex-col group-hover:bg-gray-100 border-b">
                                        //         <div className="flex items-center gap-2 p-3 bg-gray-50">
                                        //             <span className="text-xs font-medium whitespace-nowrap">Assign to manager:</span>
                                        //             <select
                                        //                 className="text-xs border border-gray-300 rounded px-2 py-1.5 min-w-[180px]"
                                        //                 value={selectedManagerForRow[rowKey]?.email || ""}
                                        //                 onChange={(e) => {
                                        //                     const email = e.target.value;
                                        //                     const opt = e.target.options[e.target.selectedIndex];
                                        //                     const name = opt?.label || email;
                                        //                     setSelectedManagerForRow((prev) => ({ ...prev, [rowKey]: email ? { email, name } : null }));
                                        //                 }}
                                        //             >
                                        //                 <option value="">Select manager</option>
                                        //                 {getFilteredManagersForRow(row).map((g) => {
                                        //                     const emp = g?.employeeId;
                                        //                     const email = emp?.EmpEmail || "";
                                        //                     const name = [emp?.EmpFirstName, emp?.EmpLastName].filter(Boolean).join(" ") || email;
                                        //                     return <option key={email} value={email}>{name}</option>;
                                        //                 })}
                                        //             </select>
                                        //             <button
                                        //                 type="button"
                                        //                 className="text-xs bg-indigo-600 text-white px-3 py-1.5 rounded hover:bg-indigo-700 disabled:opacity-50"
                                        //                 onClick={() => handleForwardToManager(row)}
                                        //                 disabled={!selectedManagerForRow[rowKey]?.email}
                                        //             >
                                        //                 Forward
                                        //             </button>
                                        //         </div>
                                        //     </div>
                                        // ) : (
                                            <div className={`flex flex-col  group-hover:bg-gray-100 `}>
                                                <ProjectApprovedSub
                                                    handleparentrefresh={handleparentrefresh}
                                                    rowData={rowData}
                                                    row={row}
                                                    employees={employees}
                                                    setIsLoading={setIsLoading}
                                                    isViewOnly={isViewOnly}
                                                />
                                            </div>
                                        // )
                                    ) : (
                                        <div
                                            onClick={() => {
                                                setrowid(prev => prev === rowKey ? null : rowKey);
                                                setSelected(!selected);
                                            }}
                                            className={` ${rowid ? "w-full" : "w-[20%]"} border-b  cursor-pointer  flex justify-center align-middle items-center`}
                                        >
                                            {rowid ? (
                                                <div className='flex group-hover:bg-gray-100'>
                                                    <div className="w-36  p-2 py-4 "></div>
                                                    <div className="w-80  p-2 py-4 break-words text-wrap flex justify-center align-middle items-center ">
                                                        Multiple
                                                    </div>
                                                    <div className="w-32  p-2 py-4 "></div>
                                                </div>
                                            ) : (
                                                <div>Multiple</div>
                                            )}
                                        </div>
                                    )}

                                </div>
                            );
                            })
                        ) : (
                            <div className="flex justify-center items-center p-8 text-gray-500">
                                {searchQuery ? "No results found for your search." : "No data available."}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div
                className={`pagination flex justify-between  text-xs items-center bg-white mt-2 rounded-md ${paginatedProjects.length > 0 ? "p-1" : ""
                    } `}
            >
                <div>
                    {totalItems > 0 ? (
                        <>
                            Showing {startIdx + 1} to{" "}
                            {Math.min(endIdx, totalItems)} of {totalItems} Entries
                        </>
                    ) : (
                        <>
                            {paginatedProjects.length > 0 && (
                                <>Showing {paginatedProjects.length} Entries</>
                            )}
                        </>
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="flex">
                        <button
                            onClick={() => setCurrentPage(1)}
                            className="px-2 py-2 mx-1 border rounded"
                            disabled={currentPage === 1}
                            title="First Page"
                        >
                            <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                        </button>
                        <button
                            onClick={() =>
                                setCurrentPage((prev) => Math.max(prev - 1, 1))
                            }
                            className="px-2 py-2 mx-2 border rounded"
                            disabled={currentPage === 1}
                        >
                            <ChevronRightIcon className="w-5 h-5 rotate-180" />
                        </button>

                        {Array.from({ length: 3 }, (_, index) => {
                            const pageNumber = currentPage - 1 + index;
                            if (pageNumber >= 1 && pageNumber <= totalPages) {
                                return (
                                    <button
                                        key={pageNumber}
                                        onClick={() => setCurrentPage(pageNumber)}
                                        className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                                            ? "bg-gray-300"
                                            : ""
                                            }`}
                                    >
                                        {pageNumber}
                                    </button>
                                );
                            }
                            return null;
                        })}

                        <button
                            onClick={() =>
                                setCurrentPage((prev) =>
                                    Math.min(prev + 1, totalPages)
                                )
                            }
                            className="px-2 py-2 mx-2 border rounded"
                            disabled={currentPage === totalPages}
                        >
                            <ChevronRightIcon className="w-5 h-5" />
                        </button>

                        <button
                            onClick={() => setCurrentPage(totalPages)}
                            className="px-2 py-2 mx-1 border rounded"
                            disabled={currentPage === totalPages}
                            title="Last Page"
                        >
                            <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                        </button>
                    </div>
                )}
            </div>

            {showAttach && (
                <FileUploadSales
                    setShowAttach={setShowAttach}
                    currentProject={currentProject}
                    employees={employees}
                    isViewOnly={isViewOnly}
                />
            )}
        </div>
    );
}

export default ApprovedSales;